// Wire contract of the email-change and password-notice callables: shipped apps decode these values, so never rename one.

export enum EmailChangeRequestOutcome {
  Sent = 'sent',
  InvalidEmail = 'invalidEmail',
  SameEmail = 'sameEmail',
  EmailTaken = 'emailTaken',
  RateLimited = 'rateLimited',
  // The app reauthenticates right before it asks, so these two only answer a caller that skipped the app.
  NotRecentSignIn = 'notRecentSignIn',
  NoPassword = 'noPassword',
}

export type RequestEmailChangeRequest = { newEmail: string };

export type RequestEmailChangeResponse = { outcome: EmailChangeRequestOutcome };

export enum EmailChangeConfirmOutcome {
  Confirmed = 'confirmed',
  // Unknown, used, expired, or the account's address moved on since the link was sent.
  InvalidLink = 'invalidLink',
  EmailTaken = 'emailTaken',
}

export type ConfirmEmailChangeRequest = { token: string };

export type ConfirmEmailChangeResponse =
  | { outcome: EmailChangeConfirmOutcome.Confirmed; email: string }
  | {
      outcome:
        | EmailChangeConfirmOutcome.InvalidLink
        | EmailChangeConfirmOutcome.EmailTaken;
    };

export enum EmailChangeRevertOutcome {
  Reverted = 'reverted',
  InvalidLink = 'invalidLink',
  // Another account took the old address in the meantime; only support can untangle that.
  EmailTaken = 'emailTaken',
  WeakPassword = 'weakPassword',
}

export type RevertEmailChangeRequest = { token: string; password: string };

export type RevertEmailChangeResponse =
  | { outcome: EmailChangeRevertOutcome.Reverted; email: string }
  | {
      outcome:
        | EmailChangeRevertOutcome.InvalidLink
        | EmailChangeRevertOutcome.EmailTaken
        | EmailChangeRevertOutcome.WeakPassword;
    };

export enum PasswordChangeNoticeOutcome {
  Sent = 'sent',
  NotRecentSignIn = 'notRecentSignIn',
  RateLimited = 'rateLimited',
}

export type NotifyPasswordChangedResponse = {
  outcome: PasswordChangeNoticeOutcome;
};

// What the change-email form tells the user.
export enum ChangeEmailErrorKind {
  WrongPassword = 'wrong-password',
  InvalidEmail = 'invalid-email',
  SameEmail = 'same-email',
  EmailTaken = 'email-taken',
  TooManyRequests = 'too-many-requests',
  Network = 'network',
  Unknown = 'unknown',
}
